<template>
  <div class="product-privacy-main" :class="{ 'product-privacy-main-mobile': isMobile}">
    <Base-title title="产品中的隐私保护"></Base-title>
    <div class="product-privacy-content">
      <div
        class="item"
        v-for="item in dataList"
        :key="item.key"
        :style="{ backgroundImage: `url(${item.bgImage})` }"
      ></div>
    </div>
  </div>
</template>
<script>
  export default {
    // 产品中的隐私保护
    name: 'ProductPrivacy',
    data() {
      return {
        dataList: [
          { bgImage: require('@/assets/images/homePage/product-beike.png'), key: 'beike' },
          { bgImage: require('@/assets/images/homePage/product-lianjia.png'), key: 'lianjia' },
          { bgImage: require('@/assets/images/homePage/product-beiwo.png'), key: 'beiwo' }
        ]
      };
    }
  };
</script>
<style lang="scss" scoped>
  .product-privacy-main {
    display: flex;
    align-items: center;
    padding-top: 1.04rem;
    width: 100%;
    height: 5.37rem;
    flex-direction: column;
  }

  .product-privacy-content {
    display: flex;
    margin-top: 0.92rem;

    .item {
      margin: 0 0.28rem;
      width: 4.37rem;
      height: 2.09rem;
      background-repeat: no-repeat;
      background-size: 100%;
    }
  }
  .product-privacy-main-mobile {
    height: 11.42rem;
    padding-top: 2.1rem;
    .product-privacy-content {
      display: flex;
      margin-top: 1.38rem;

      .item {
        margin: 0 0.28rem;
        width: 5.38rem;
        height: 2.61rem;
        background-repeat: no-repeat;
        background-size: 100%;
      }
    }
  }
</style>
